import { useMemo } from 'react'

import { InitialConfigType } from '@eastcoal/editor/exports'

import { editorNodes } from '../../nodes'
import { useEditorTheme } from '../../theme'

export const useLexicalConfig = (): InitialConfigType => {
  const editorTheme = useEditorTheme()

  return useMemo(
    () => ({
      namespace: 'ContractDesignerEditor',
      theme: editorTheme,
      nodes: editorNodes,
      onError(...args: any[]) {
        console.error('[ContractDesignerEditor]', ...args)
      }
    }),
    [editorTheme]
  )
}
